import { legacyPlugins } from "/home/runner/work/fc-datastore/fc-datastore/client-v3/node_modules/.pnpm/@unhead+vue@3.4.3_@oxc-project+types@0.156.0_esbuild@0.28.2_lightningcss@1.33.0_oxc-par_117ec0ee6b8fa97a7128e6518eca3da3/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}